export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/';
export const FRONT_URL = process.env.REACT_APP_FRONT_URL || 'http://localhost:3000/';
export const AGORA_APP_ID = process.env.REACT_APP_AGORA_APP_ID;
export const AGORA_CHANNEL_NAME = process.env.REACT_APP_AGORA_CHANNEL_NAME;
export const AGORA_APP_TOKEN = process.env.REACT_APP_AGORA_APP_TOKEN;

